"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../../hooks");
/**
 * # 📭 EmptyState
 *
 * A generic state used on screens or widgets that are empty or have no data.
 *
 * ## Usage
 * ```jsx
 * <EmptyState/>
 * ```
 */
const EmptyState = (props) => {
    const ComponentState = (0, hooks_1.useComponent)('ComponentState');
    return (<ComponentState title="No data" description="There is no data to display." imageSource="Empty" {...props}/>);
};
exports.EmptyState = EmptyState;
exports.EmptyState.displayName = 'EmptyState';
